// empty-state — wireframe skin module
// Token disposition: color tokens overridden to wf-* namespace; spacing/sizing pass-through

export const styles = `
  :host {
    display: block;
    container-type: inline-size;
    background: var(--run-wf-surface);
    color: var(--run-wf-text);
  }

  [part="root"] {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: var(--run-empty-state-gap, var(--run-space-semantic-xs));
    padding-block: var(--run-empty-state-padding-block, var(--run-space-semantic-lg));
    padding-inline: var(--run-empty-state-padding-inline, var(--run-space-semantic-md));
    background: var(--run-wf-surface);
    border: 1.5px dashed var(--run-wf-border);
  }

  [part="root"][data-variant="horizontal"] {
    flex-direction: row;
    text-align: start;
    align-items: flex-start;
  }

  [part="root"][data-tone="subtle"] {
    background: var(--run-wf-surface);
    border: 1.5px dashed var(--run-wf-border);
    border-radius: var(--run-radius-semantic-card);
  }

  [part="media-wrapper"] {
    max-inline-size: 100%;
    flex-shrink: 0;
    opacity: 0.6;
    filter: grayscale(1);
  }

  [part="icon-wrapper"] {
    max-inline-size: 100%;
    flex-shrink: 0;
    opacity: 0.6;
    filter: grayscale(1);
    color: var(--run-wf-text-subtle);
    font-size: var(--run-empty-state-icon-size, var(--run-size-icon-xl));
  }

  [part="icon-wrapper"][data-icon-hidden] {
    display: none;
  }

  [part="heading-wrapper"] {
    color: var(--run-wf-text);
    font-size: var(--run-empty-state-title-font-size, var(--run-font-size-lg));
    font-weight: 400;
    font-family: var(--run-wf-font-family);
  }

  [part="description-wrapper"] {
    max-inline-size: var(--run-empty-state-max-width, 40ch);
    color: var(--run-wf-text-subtle);
    font-size: var(--run-empty-state-body-font-size, var(--run-font-size-base));
    font-family: var(--run-wf-font-family);
    font-weight: 400;
  }

  [part="actions-wrapper"] {
    display: inline-flex;
    flex-wrap: wrap;
    gap: var(--run-space-semantic-sm);
  }

  [part="root"][data-size="lg"] [part="media-wrapper"],
  [part="root"][data-size="lg"] [part="icon-wrapper"] {
    block-size: var(--run-empty-state-illustration-lg, 64px);
  }

  /* 480px literal per contract.md (--run-empty-state-collapse-breakpoint is
     informational only — size container queries cannot read custom properties) */
  @container (inline-size < 480px) {
    [part="root"][data-variant="horizontal"] {
      flex-direction: column;
      text-align: center;
      align-items: center;
    }
  }
`;

export function render(host) {
  const { size, variant, headingLevel, tone, _mediaSlotted, _iconSlotted } = host;

  const iconHiddenAttr = _mediaSlotted ? ' data-icon-hidden' : '';

  host.shadowRoot.innerHTML = `
    <div part="root" data-size="${size}" data-variant="${variant}" data-tone="${tone}">
      <div part="media-wrapper" aria-hidden="true">
        <slot name="media"></slot>
      </div>
      <div part="icon-wrapper" aria-hidden="true"${iconHiddenAttr}>
        <slot name="icon"></slot>
      </div>
      <div part="heading-wrapper">
        <h${headingLevel}>
          <slot name="heading"></slot>
        </h${headingLevel}>
      </div>
      <div part="description-wrapper">
        <slot></slot>
      </div>
      <div part="actions-wrapper">
        <slot name="actions"></slot>
      </div>
    </div>
  `;
}